import { Flex } from '@chakra-ui/react';

type HeroIcon = React.ComponentType<React.SVGProps<SVGSVGElement>>;

export interface TabIconProps {
  focused: boolean;
  OutlineIcon: HeroIcon;
  SolidIcon: HeroIcon;
  tabKey?: string;
  activeColor?: string;
  inactiveColor?: string;
  size?: number;
}

const DEFAULT_ACTIVE_COLOR = '#1F2932';
const DEFAULT_INACTIVE_COLOR = '#5A6C84';
const DEFAULT_SIZE = 28;

export function TabIcon({
  focused,
  OutlineIcon,
  SolidIcon,
  activeColor = DEFAULT_ACTIVE_COLOR,
  inactiveColor = DEFAULT_INACTIVE_COLOR,
  size = DEFAULT_SIZE,
}: TabIconProps) {
  return (
    <Flex position="relative" justify="center" align="center" w={`${size}px`} h={`${size}px`} pointerEvents="none" flexShrink={0}>
      <Flex
        position="absolute"
        justify="center"
        align="center"
        pointerEvents="none"
        transition="all 0.2s"
        opacity={focused ? 0 : 1}
        transform={focused ? 'scale(0.5)' : 'scale(1)'}
      >
        <OutlineIcon
          width={size}
          height={size}
          style={{
            display: 'block',
            flexShrink: 0,
            color: focused ? activeColor : inactiveColor,
            stroke: focused ? activeColor : inactiveColor,
          }}
        />
      </Flex>
      <Flex
        position="absolute"
        justify="center"
        align="center"
        pointerEvents="none"
        transition="all 0.2s"
        opacity={focused ? 1 : 0}
        transform={focused ? 'scale(1)' : 'scale(0.5)'}
      >
        <SolidIcon
          width={size}
          height={size}
          style={{
            display: 'block',
            flexShrink: 0,
            color: activeColor,
            fill: activeColor,
          }}
        />
      </Flex>
    </Flex>
  );
}
